import { createUdzsAuthClient } from "udzs-common/auth";

import { ENV } from "@/env";

export const skAuthClient = createUdzsAuthClient({
  issuer: ENV.VITE_AUTH_ISSUER,
  clientId: "sk",
  redirectPath: "/oauth/redirect",
  logoutRedirectPath: "/oauth/logout",
  timeReserveMs: 10000,
  localstorageAuthKey: "sk-auth",
  basename: ENV.VITE_BASENAME,
});

export const skMeApi = `${ENV.VITE_API_BASE_PATH}/me`;
